import { render, staticRenderFns } from "./downloadapp.vue?vue&type=template&id=5a2a41b8&scoped=true&"
import script from "./downloadapp.vue?vue&type=script&lang=js&"
export * from "./downloadapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a41b8",
  null
  
)

export default component.exports